// extracted by mini-css-extract-plugin
module.exports = {"container":"b49a62dc46--container--Bcr54","item":"b49a62dc46--item--_mFE0","textblock":"b49a62dc46--textblock--I9fnS","link":"b49a62dc46--link--yLGs8"};